

























































import { includes, isNull, omitBy } from 'lodash';
import Vue from 'vue';
import { ZenFormGroup } from 'zenComponents';
import { BAlert, BFormCheckbox, BFormInput, BFormSelect } from 'bootstrap-vue';
import GenericCard from '@/components/cards/GenericCard.vue';
import { saveCustomAttribute } from '@/utils/crudActions';

import { CustomAttributeDefinition } from './types';

export default Vue.extend({
  name: 'CadEditModal',
  components: {
    BFormCheckbox,
    ZenFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    GenericCard,
  },
  props: {
    allowRequired: {
      type: Boolean,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    initialDefinition: {
      type: Object as () => CustomAttributeDefinition,
      required: true,
    },
    definitionTypeTitle: {
      type: String,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
    postUrl: {
      type: String,
      required: true,
    },
    redirectUrl: {
      type: String,
      required: true,
    },
  },
  /* eslint-disable complexity */
  data() {
    return {
      allTypes: ['Text', 'Rich Text', 'Date', 'Number', 'Checkbox', 'Dropdown', 'Map:Person'],
      definition: <CustomAttributeDefinition>{
        title: '',
        helptext: null,
        mandatory: false,
        multiChoiceOptions: null,
        placeholder: null,
        attributeType: 'Text',
        ...this.initialDefinition,
      },
      errors: [],
      allowDecimal: this.initialDefinition.attributeType === 'Decimal',
      allowMultichoice: this.initialDefinition.attributeType === 'Multi choice',
    };
  },
  /* eslint-enable complexity */
  computed: {
    title(): string {
      return (
        `${this.edit ? 'Edit' : 'Create a'} custom attribute ` +
        `${this.definition.title || ''} for ${this.definitionTypeTitle}`
      );
    },
    hasPlaceholder(): boolean {
      return includes(['Text', 'Rich Text'], this.definition.attributeType);
    },
    isNumber(): boolean {
      return this.attributeType === 'Number';
    },
    isDropdown(): boolean {
      return this.attributeType === 'Dropdown';
    },
    attributeType: {
      get() {
        if (includes(['Integer', 'Decimal'], this.definition.attributeType)) {
          return 'Number';
        } else if ('Multi choice' === this.definition.attributeType) {
          return 'Dropdown';
        }

        return this.definition.attributeType;
      },
      set(newValue) {
        this.updateType(newValue);
      },
    },
  },
  watch: {
    allowDecimal() {
      this.updateType('Number');
    },
    allowMultichoice() {
      this.updateType('Dropdown');
    },
  },
  created() {
    if (this.$parent) {
      this.$parent.$on('close', this.redirect);
    }
  },
  methods: {
    updateType(newValue) {
      if (newValue === 'Number') {
        this.definition.attributeType = this.allowDecimal ? 'Decimal' : 'Integer';
      } else if (newValue === 'Dropdown') {
        this.definition.attributeType = this.allowMultichoice ? 'Multi choice' : 'Dropdown';
      } else {
        this.definition.attributeType = newValue;
      }
    },
    async postToServer() {
      const data = omitBy(this.definition, value => isNull(value) || value === '');
      if (!this.hasPlaceholder) {
        delete data.placeholder;
      }

      try {
        const response = await this.saveCustomAttribute({
          csrf: this.csrfToken,
          url: this.postUrl,
          data,
        });

        if (!response.success) {
          throw response.errors;
        } else {
          this.redirect();
        }
      } catch (errors) {
        this.errors = errors;
      }
    },
    redirect() {
      window.location.href = this.redirectUrl;
    },
    saveCustomAttribute,
  },
});
